import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightAlt = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.33331 14.1667L12.5 10L8.33331 5.83334V14.1667Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowRightAlt);
export default ForwardRef;
